import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Slider, Button } from "../../../../theme";

const Container = styled.section`
  p {
    margin-bottom: 5px;

    @media (max-width: 1599px) {
      font-size: 1.3rem;
    }

    @media (max-width: 1023px) {
      maring: 0;
    }
  }

  > div:last-of-type {
    margin-top: 30px;
    text-align: center;
  }
`;

const Flex = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  > div {
    margin: 15px 0;
    width: calc(25% - 30px);

    @media (max-width: 1023px) {
      margin: 15px 0 0;
      width: calc(50% - 30px);
    }

    @media (max-width: 767px) {
      width: 100%;
    }
  }
`;

function CovidHerdImmunityInputs({ updateSimulation }) {
  const [prob, setProb] = useState(100);
  const [quarantine, setQuarantine] = useState(0);
  const [confinedPopulation, setConfinedPopulation] = useState(0);
  const [immunePopulation, setImmunePopulation] = useState(0);

  const handleClick = () => {
    updateSimulation({
      prob: prob / 100,
      quarantine: quarantine / 100,
      confinedPopulation: confinedPopulation / 100,
      immunePopulation: immunePopulation / 100,
    });
  };

  return (
    <Container>
      <Flex>
        <div>
          <p>Risque de transmission</p>
          <Slider
            min={0}
            max={100}
            step={10}
            value={prob}
            onChange={(e, val) => setProb(val)}
            valueLabelDisplay="on"
          />
        </div>
        <div>
          <p>Quarantaine</p>
          <Slider
            min={0}
            max={100}
            step={5}
            value={quarantine}
            onChange={(e, val) => setQuarantine(val)}
            valueLabelDisplay="on"
          />
        </div>
        <div>
          <p>Population confinée</p>
          <Slider
            min={0}
            max={100}
            step={10}
            value={confinedPopulation}
            onChange={(e, val) => setConfinedPopulation(val)}
            valueLabelDisplay="on"
          />
        </div>
        <div>
          <p>Population immunisée</p>
          <Slider
            min={0}
            max={100}
            step={10}
            value={immunePopulation}
            onChange={(e, val) => setImmunePopulation(val)}
            valueLabelDisplay="on"
          />
        </div>
      </Flex>
      <div>
        <Button onClick={handleClick}>Tester les nouveaux paramètres</Button>
      </div>
    </Container>
  );
}

CovidHerdImmunityInputs.propTypes = {
  updateSimulation: PropTypes.func.isRequired,
};

export default CovidHerdImmunityInputs;
